var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuTeacher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/teacher",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,8.78 C6.67946393,10.8324518 9.72323587,11.4442332 12.342,10.316",
    id: "path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path",
    cx: 8.249,
    cy: 10.875,
    r: 4.125
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path",
    cx: 11.999,
    cy: 12,
    r: 11.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.987,22.848 C14.8242244,20.0941168 13.0018005,17.7165329 10.3847878,16.8438284 C7.76777515,15.9711239 4.88308167,16.7790087 3.1,18.884",
    id: "path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path",
    cx: 17.624,
    cy: 13.125,
    r: 2.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.274,18.368 C20.3426972,17.0761322 18.7979339,16.3727236 17.2120496,16.5183891 C15.6261653,16.6640545 14.2353862,17.6370965 13.555,19.077",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTeacher);
export default __webpack_public_path__ + "static/media/menu-teacher.11128aa2903264f69c2646e74e2419d6.svg";
export { ForwardRef as ReactComponent };